<!-- Spinner -->
<ng-template #spinner>
  <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
</ng-template>

<!-- No Data Template -->

<!-- Edit -->
@if (searchControlFacade.currentSelectedMedia$ | async; as media) {
  <div
    class="flex flex-1 overflow-hidden flex-column row-gap-2 p-2 mb-6">
    <p-splitter class="flex flex-1 overflow-hidden justify-content-center h-full mb-2"
      styleClass="w-full"
      panelStyleClass="min-w-4_5rem"
      [gutterSize]="FlatModels.PanelDesignModels.panelGutterSizeBig"
      [panelSizes]="[40, 60]"
      [minSizes]="[FlatModels.PanelDesignModels.panelMinSizeVerySmall, FlatModels.PanelDesignModels.panelMinSizeVerySmall]"
      layout="vertical">
      <ng-template pTemplate>
        <div class="flex flex-1 flex-column overflow-hidden row-gap-2 justify-content-center align-items-center mb-2"
          >
          @switch (media.type) {
            @case (FlatModels.MediaEntityModels.MediaType.enum.MediaImage) {
              <img
                class="w-full h-full max-h-20rem object-fit-contain"
                [src]="mediaControlService.getUrl(media, 'file') || '/assets/images/no-image.png'"
                [alt]="media?.name || 'global.error_loading_image' | translate"
                id="image-{{media.id}}" />
            }
            @case (FlatModels.MediaEntityModels.MediaType.enum.MediaDeepzoom) {
              <img
                class="w-full h-full max-h-20rem object-fit-contain"
                [src]="mediaControlService.getUrl(media, 'file') || '/assets/images/no-image.png'"
                [alt]="media?.name || 'global.error_loading_image' | translate"
                id="deepzoom-{{media.id}}" />
            }
            @case (FlatModels.MediaEntityModels.MediaType.enum.MediaVideo) {
              <video #videoPlayer
                crossorigin="anonymous"
                [src]="mediaControlService.getUrl(media)"
                [poster]="mediaControlService.getUrl(media, 'poster') || mediaControlService.getUrl(media, 'thumbnail') || '/assets/images/no-image.png'"
                id="video-{{media.id}}"
                class="w-full h-full max-h-20rem"
                preload="auto"
              controls></video>
            }
            @case (FlatModels.MediaEntityModels.MediaType.enum.MediaAudio) {
              <audio
                [src]="mediaControlService.getUrl(media)"
                class="w-full h-3rem max-w-full max-h-20rem"
                id="audio-{{media.id}}"
              controls></audio>
            }
            @case (FlatModels.MediaEntityModels.MediaType.enum.MediaDocument) {
              <i
              [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MEDIA_DOCUMENT + ' fa-3x'"></i>
            }
          }
        </div>
      </ng-template>
      <ng-template pTemplate>
        <p-tabView class="w-full"
          styleClass="flex flex-column row-gap-2 h-full">
          <!-- Settings -->
          <p-tabPanel [header]="'global.settings' | translate"
            class="flex max-h-full">
            <div class="flex flex-column row-gap-2 overflow-auto h-full">
              @if (mediaForm) {
                <medsurf-design-form-control-form
                  [formGroup]="mediaForm"
                  [class]="'w-full'"
                  (onSubmit)="onSubmit()">
                  <div class="flex flex-column align-items-center">
                    <!-- Name -->
                    <medsurf-design-form-control-input-text [control]="mediaForm.controls.name"
                      [class]="'w-full'"
                      [label]="'global.name'"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
                    <!-- Alt Text -->
                    <medsurf-design-form-control-input-text [control]="mediaForm.controls.altText"
                      [class]="'w-full'"
                      [label]="'global.alt_text'"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
                    <!-- Access -->
                    <medsurf-design-form-control-input-dropdown [control]="mediaForm.controls.access"
                      [options]="FlatModels.MediaEntityModels.MediaAccessArray"
                      [class]="'w-full'"
                      [disabled]="mediaControlService.isDeepzoom(media)"
                      [label]="'global.access'"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
                    <!-- Compound Number -->
                    <medsurf-design-form-control-input-text [control]="mediaForm.controls.compoundNumber"
                      [class]="'w-full'"
                      [label]="'global.compound_number'"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
                    <!-- Stain -->
                    @if (constantAuthorFacade.stainArray$ | async; as stainArray) {
                      <medsurf-design-form-control-input-dropdown
                        [control]="mediaForm.controls.stain"
                        [options]="stainArray"
                        [filter]="true"
                        [showClear]="true"
                        [class]="'w-full'"
                        [placeholder]="'global.stain'"
                        [label]="'global.stain'"
                      (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
                    }
                  </div>
                </medsurf-design-form-control-form>
              }
              @if (media.type === FlatModels.MediaEntityModels.MediaType.enum.MediaDeepzoom) {
                @if (mediaDimensionForm) {
                  <medsurf-design-form-control-form
                    [formGroup]="mediaDimensionForm"
                    [class]="'w-full'"
                    (onSubmit)="onDimensionSubmit()">
                    <div class="flex flex-column align-items-center">
                      <!-- Pixel Per Millimeter -->
                      <medsurf-design-form-control-input-number [control]="mediaDimensionForm.controls.pixelPerMillimeter"
                        [class]="'w-full'"
                        [label]="'global.pixel_per_millimeter'"
                      (valueChange)="onDimensionSubmit()"></medsurf-design-form-control-input-number>
                      <!-- Depth -->
                      <medsurf-design-form-control-input-text [control]="mediaDimensionForm.controls.depth"
                        [class]="'w-full'"
                        [label]="'global.layer_depth'"
                      (valueChange)="onDimensionSubmit()"></medsurf-design-form-control-input-text>
                    </div>
                  </medsurf-design-form-control-form>
                }
              }
            </div>
          </p-tabPanel>
          <!-- Poster -->
          @if (media?.type === FlatModels.MediaEntityModels.MediaType.enum.MediaVideo) {
            <p-tabPanel
              [header]="'global.poster' | translate"
              class="flex max-h-full">
              <div class="flex flex-column row-gap-2 overflow-auto h-full">
                <div class="flex flex-column row-gap-2 align-items-center row-gap-4">
                  <!-- Poster Image -->
                  <img class="w-auto max-w-full max-h-20rem"
                    [src]="mediaControlService.getUrl(media, 'poster') || '/assets/images/no-image.png'"
                    [alt]="media?.name || 'global.error_loading_image' | translate"
                    id="image-poster-{{media.id}}" />
                  <div class="flex flex-row flex-wrap justify-content-start align-items-center row-gap-2 column-gap-2 w-full">
                    <!-- Replace Poster -->
                    <button medsurf-design-input-button type="button" [id]="'upload_custom_poster'" 
                      [label]="'global.upload_custom_poster' | translate"
                    (click)="uploadPoster()"></button>
                    <!-- Upload Video Frame -->
                    <button medsurf-design-input-button type="button"
                      [id]="'poster_from_video'"
                      [label]="'global.poster_from_video' | translate"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.UPLOAD"
                    (click)="uploadPosterFromVideoFrame()"></button>
                  </div>
                </div>
              </div>
            </p-tabPanel>
          }
          <!-- Copyrights & Watermark -->
          <p-tabPanel [header]="'global.copyright' | translate"
            class="flex max-h-full">
            <div class="flex flex-column row-gap-2 overflow-auto h-full">
              <!-- Copyrights -->
              <div class="flex flex-column row-gap-2 align-items-center">
                <label class="flex flex-grow-1 align-self-start">
                  <span class="white-space-wrap overflow-hidden text-overflow-ellipsis" translate="global.copyrights"></span>
                </label>
                @if (media && media.mediaCopyrights && media.mediaCopyrights.length > 0) {
                  @if (media.mediaCopyrights | sortBy_shared:'asc':'order'; as mediaCopyrights) {
                    <div class="w-full"
                         [dragula]="getDragulaKey('copyrights')"
                         [dragulaModel]="mediaCopyrights"
                         (dragulaModelChange)="onMediaCopyrightMoved($event)">
                      @for (mediaCopyright of mediaCopyrights; track mediaCopyrightTrackBy($index, mediaCopyright)) {
                        <div class="flex flex-1 gap-2 drag-node mb-3">
                          <button medsurf-design-input-button [id]="'media_copyright_handle_' + mediaCopyright.copyright"
                                  [title]="'global.drag_node' | translate"
                                  [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
                                  [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
                                  [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
                          <medsurf-common-media-library-media-sidebar-copyright
                            [class]="'overflow-auto flex-grow-1'"
                            [mediaCopyright]="mediaCopyright"></medsurf-common-media-library-media-sidebar-copyright>
                        </div>
                      }
                    </div>
                  }
                }
                @if (copyrightForm) {
                  <medsurf-design-form-control-form
                    [formGroup]="copyrightForm"
                    [class]="'w-full'"
                    (onSubmit)="onCopyrightSubmit()">
                    <!-- Copyright -->
                    @if (constantAuthorFacade.copyrightArray$ | async; as copyrightArray) {
                      <medsurf-design-form-control-input-dropdown
                        [control]="copyrightForm.controls.id"
                        [filter]="true"
                        [class]="'w-full align-self-start'"
                        [placeholder]="'global.copyright_add'"
                        [options]="copyrightArray"
                      (valueChange)="onCopyrightSubmit()"></medsurf-design-form-control-input-dropdown>
                    }
                  </medsurf-design-form-control-form>
                }
              </div>
              @if (mediaPositionForm) {
                <medsurf-design-form-control-form
                  [formGroup]="mediaPositionForm"
                  [class]="'w-full'"
                  (onSubmit)="onPositionSubmit()">
                  @if (mediaControlService.isImage(media)) {
                    <div
                      class="flex flex-column align-items-center row-gap-2">
                      <!-- Watermark -->
                      <medsurf-design-form-control-input-watermark-position-select-button [control]="mediaPositionForm.controls.copyrightPosition"
                        [class]="'w-full align-self-start'"
                        [label]="'global.watermark'"
                      (valueChange)="onPositionSubmit()"></medsurf-design-form-control-input-watermark-position-select-button>
                    </div>
                  }
                </medsurf-design-form-control-form>
              }
            </div>
          </p-tabPanel>
          <!-- Metadata -->
          <p-tabPanel [header]="'global.metadata' | translate"
            class="flex max-h-full">
            <div class="flex flex-column row-gap-2 overflow-auto row-gap-2 h-full">
              <!-- Media id -->
              <div class="flex flex-row column-gap-2 cursor-pointer" (click)="clipboardAuthorFacade.requestCopyToClipboard(media.id)">
                <div class="flex">
                  <b>{{ 'global.media_id' | translate }}</b>
                </div>
                <div class="flex">
                  {{ media.id }}
                </div>
              </div>
              <!-- File Type -->
              <div class="flex flex-row column-gap-2">
                <div class="flex">
                  <b>{{ 'global.file_type' | translate }}</b>
                </div>
                <div class="flex">
                  {{ media.mime }}
                </div>
              </div>
              <!-- Size -->
              <div class="flex flex-row column-gap-2">
                <div class="flex">
                  <b>{{ 'global.size' | translate }}</b>
                </div>
                <div class="flex">
                  {{ media.size * 1024 * 1024 | fileSize }}
                </div>
              </div>
              <!-- Resolution -->
              @if ((mediaControlService.isVideo(media) || mediaControlService.isImage(media) || mediaControlService.isDeepzoom(media))) {
                <div
                  class="flex flex-row column-gap-2">
                  <div class="flex">
                    <b>{{ 'global.resolution' | translate }}</b>
                  </div>
                  <div class="flex">
                    {{ media.dimensions?.width ?? 0 }} x {{ media.dimensions?.height ?? 0 }} px
                  </div>
                  @if (media.dimensions?.pixelPerMillimeter) {
                    <div
                      class="flex">
                      <span>&#64; {{ media.dimensions?.pixelPerMillimeter ?? 0 }} px/mm</span>
                    </div>
                  }
                </div>
              }
              <!-- Duration -->
              @if (mediaControlService.isVideo(media) || mediaControlService.isAudio(media)) {
                <div
                  class="flex flex-row column-gap-2">
                  <div class="flex">
                    <b>{{ 'global.duration' | translate }}</b>
                  </div>
                  <div class="flex">
                    {{ media.duration ?? 0 | duration_shared }}
                  </div>
                </div>
              }
              <!-- Uploaded At -->
              <div class="flex flex-row column-gap-2">
                <div class="flex">
                  <b>{{ 'global.uploaded_at' | translate }}</b>
                </div>
                <div class="flex">
                  {{ media.uploadedAt | date_shared }}
                </div>
              </div>
              <!-- Uploaded By -->
              @if (searchControlFacade.user$(media.uploadedBy) | async; as user) {
                <div
                  class="flex flex-row column-gap-2">
                  <div class="flex">
                    <b>{{ 'global.uploaded_by' | translate }}</b>
                  </div>
                  <div class="flex">
                    {{ user.lastName }} {{ user.firstName }}
                  </div>
                </div>
              }
              <!-- Used In -->
              <div class="flex flex-column row-gap-2">
                <div class="flex">
                  <b>{{ 'global.images_remove_used_in' | translate }}</b>
                </div>
                <ul class="my-0">
                  @for (entry of mediaAuthorFacade.mediaUsedInById$(media.id) | async; track trackByIds($index, entry)) {
                    <li class="p-1 opacity-50 text-500">
                      <a [href]="'/node/' + entry.id" target="_blank" class="text-primary hover:underline">{{ entry.title }}</a>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </p-tabPanel>
          <!-- Comments -->
          <p-tabPanel [header]="'global.comments' | translate"
            class="flex max-h-full">
            <div class="flex overflow-auto w-full h-screen max-h-full">
              @if (mediaForm) {
                <medsurf-design-form-control-form
                  [formGroup]="mediaForm"
                  class="w-full"
                  className="h-full"
                  (onSubmit)="onSubmit()">
                  <!-- Author Note -->
                  <medsurf-editor [formField]="false"
                    [control]="mediaForm.controls.authorNote"
                    class="h-full"
                    placeholder="global.comment"
                    [fullHeight]="true"
                    [autogrow]="false"
                    [toolbarExcludes]="['mediaimage', 'mediapdf', 'mediaaudio', 'mediavideo', 'marker']"
                  (valueChange)="onSubmit()"></medsurf-editor>
                </medsurf-design-form-control-form>
              }
            </div>
          </p-tabPanel>
        </p-tabView>
      </ng-template>
    </p-splitter>
  </div>
} @else {
  <span class="m-2">
    {{ 'global.no_data' | translate }}
  </span>
}
